import { loadJson, saveJson } from '@/features/kitchen/storage/persist'

export const KITCHEN_SYNC_QUEUE_KEY = 'superoti.kitchen.syncQueue'
export const KITCHEN_SYNC_CHANGED_EVENT = 'kitchen-sync-changed'

export type KitchenSyncType =
  | 'production_post'
  | 'dispatch_save'
  | 'dispatch_handover'
  | 'waste_submit'
  | 'waste_execute'
  | 'attendance'
  | 'delman_start_trip'
  | 'delman_complete_trip'
  | 'delman_handover_qr'
  | 'delman_return_pickup'
  | 'delman_attendance'

export type KitchenSyncQueueItem = {
  id: string
  type: KitchenSyncType
  label: string
  payload: unknown
  createdAt: string
}

export function getKitchenSyncQueue(): KitchenSyncQueueItem[] {
  return loadJson<KitchenSyncQueueItem[]>(KITCHEN_SYNC_QUEUE_KEY) ?? []
}

export function getKitchenSyncQueueCount(): number {
  return getKitchenSyncQueue().length
}

export function enqueueKitchenSyncItem(
  item: Omit<KitchenSyncQueueItem, 'id' | 'createdAt'>,
): KitchenSyncQueueItem {
  const entry: KitchenSyncQueueItem = {
    ...item,
    id: `sync-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`,
    createdAt: new Date().toISOString(),
  }
  const next = [...getKitchenSyncQueue(), entry]
  saveJson(KITCHEN_SYNC_QUEUE_KEY, next)
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new CustomEvent(KITCHEN_SYNC_CHANGED_EVENT))
  }
  return entry
}

export function removeKitchenSyncItem(id: string): void {
  const next = getKitchenSyncQueue().filter((item) => item.id !== id)
  saveJson(KITCHEN_SYNC_QUEUE_KEY, next)
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new CustomEvent(KITCHEN_SYNC_CHANGED_EVENT))
  }
}

export function clearKitchenSyncQueue(): void {
  saveJson(KITCHEN_SYNC_QUEUE_KEY, [])
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new CustomEvent(KITCHEN_SYNC_CHANGED_EVENT))
  }
}
